/* global hUrl */
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-ppv')) {
  pagePpv()
}
function pagePpv() {
  //  ##  ###    ###    ###     ####    #####
  //  ##  ## #  # ##   ## ##   ##       ##
  //  ##  ##  ##  ##  ##   ##  ##  ###  #####
  //  ##  ##      ##  #######  ##   ##  ##
  //  ##  ##      ##  ##   ##   ####    #####

  let imageSlider = []
  const imageSliderItem = document.getElementsByClassName('js-imageSlider')
  if (imageSliderItem[0]) {
    for (const targetSlider of imageSliderItem) {
      const sliderName = targetSlider.dataset.slide // data-slideからスライド名を取得
      imageSliderInit(targetSlider, sliderName)
    }
  }
  function imageSliderInit(targetSlider, sliderName) {
    imageSlider[sliderName] = new Swiper(targetSlider, {
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true, // ループ
      autoHeight: true, // スライドごとに高さを変動させる
      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },
      pagination: {
        // ページャーオプション
        el: '.swiper-pagination--' + sliderName, // ページャーを呼び出す要素
        type: 'fraction', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true, // クリックでジャンプ可能にする
      },
    })

    let lastSlide = null
    window.addEventListener('click', function (e) {
      // 指定のクラスを持つ

      const item = e.target.closest('.js-slideShift--' + sliderName)
      if (item) {
        const slide = parseInt(item.dataset.slide, 10)
        if (lastSlide === slide) {
          return
        }
        imageSlider[sliderName].slideTo(slide)
        lastSlide = slide
      }
    })

    //  ##  ##  #####  ##    ##             ####  ##   ##  #####   ####  ##  ##
    //  ## ##   ##      ##  ##             ##     ##   ##  ##     ##     ## ##
    //  ####    #####    ####    ########  ##     #######  #####  ##     ####
    //  ## ##   ##        ##               ##     ##   ##  ##     ##     ## ##
    //  ##  ##  #####     ##                ####  ##   ##  #####   ####  ##  ##
    // キー操作監視
    window.addEventListener('keydown', function (e) {
      keyCheck(e)
    })
    function keyCheck(e) {
      // console.log(e.code)

      if (e.code === 'ArrowLeft') {
        imageSlider[sliderName].slidePrev(0) // speed0で移動
        return false
      }
      if (e.code === 'ArrowRight') {
        imageSlider[sliderName].slideNext(0) // speed0で移動
        return false
      }
    }
  }
}
//  ##      ##  ##  ##  #####
//  ##      ##  ## ##   ##
//  ##      ##  ####    #####
//  ##      ##  ## ##   ##
//  ######  ##  ##  ##  #####
// いいねした時の数値加算処理
window.addEventListener('click', function (e) {
  if (!e.target.classList.contains('js-clickPlus')) {
    return
  }
  const valItem = e.target.querySelector('.js-clickPlus-val')
  setTimeout(() => {
    if (e.target.classList.contains('active')) {
      valItem.innerText = parseInt(valItem.innerText, 10) + 1
    } else {
      valItem.innerText = parseInt(valItem.innerText, 10) - 1
    }
  }, 100)
})
